/*
 * The ordered overlay roots — body-level siblings of #root declared in
 * index.html. Their DOM order (modals < notifications < confirmations) is the
 * layering contract: a confirmation always paints above a notification, which
 * always paints above an open modal, regardless of mount order. See the
 * roots' CSS in index.html and src/assets/css/overlay-roots.css. OCT-4740
 */
export type OverlayRoot = 'modals' | 'notifications' | 'confirmations'

export const OVERLAY_ROOT_IDS: Record<OverlayRoot, string> = {
  modals: 'overlay-modals',
  notifications: 'overlay-notifications',
  confirmations: 'overlay-confirmations',
}
